import TaskSubtasks from 'pages/tasks/task-detail/parts/TaskSubtasks';

/**
 * Subtasks tab in the task detail page.
 */
export default function TaskSubtasksTab() {
  return <TaskSubtasks />;
}
